export default {
  generateGuid() {
    return '_' + Math.random().toString(36).substr(2, 9);
},

getAgentInfo(sessionId, UserId, pathname) {
    const windowRelatedItems = {
        Url: window.location.hostname + pathname,
        QueryString: window?.location.search,
        UserAgent: window.navigator.userAgent,
        Width: window.screen.availWidth,
        Height: window.screen.availHeight,
        Platform: window.navigator.platform,
        Referrer: window.document.referrer,
        Vendor: window.navigator.vendor,
    };
    const commonItems = { SessionId: sessionId, UserId: UserId }
    if (typeof window !== "undefined") {
        return { ...commonItems, ...windowRelatedItems };
    } else return commonItems
},

  sendRequest({ params, token, jwt, apiUrl }) {
    const http = new XMLHttpRequest();
    const url = `${apiUrl}/v1/public/page-log`;
    http.open('POST', url, true);
    http.setRequestHeader("Content-type", "application/json");
    http.setRequestHeader("token", token);
    http.setRequestHeader("Authorization", `Bearer ${jwt}`);
    http.send(JSON.stringify(params));
}
}